export const FOLLOWUP_FILTROS = {
  IMPORT_AEREO: [
    { name: 'servicoProduto', value: 'AGENCIAMENTO_IMPORTACAO' },
    { name: 'viaTransporteCode', value: '04' },
  ],
  IMPORT_MARITIMO: [
    { name: 'servicoProduto', value: 'AGENCIAMENTO_IMPORTACAO' },
    { name: 'viaTransporteCode', value: '01' },
  ],
  EXPORT_AEREO: [
    { name: 'servicoProduto', value: 'AGENCIAMENTO_EXPORTACAO' },
    { name: 'viaTransporteCode', value: '04' },
  ],
  EXPORT_MARITIMO: [
    { name: 'servicoProduto', value: 'AGENCIAMENTO_EXPORTACAO' },
    { name: 'viaTransporteCode', value: '01' },
  ],
};

export default FOLLOWUP_FILTROS;